import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCustomer } from '../Services/customerServices';
import { verifyToken } from '../Services/authService';
import { useNavigate } from 'react-router-dom';

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState({});
  const [enableTutorials, setEnableTutorials] = useState(false);


  // Function to set customer data
  const setCustomerData = (data) => {
    setCustomer(data);
    setEnableTutorials(data.enableTutorial);
  };



  // Function to reload customer data
  const reloadCustomerData = async () => {
    const isTokenValid = await verifyToken()
    if (isTokenValid.success) {
      const enduser = localStorage.getItem("enduser");
      if (enduser) {
        var tmpData = JSON.parse(enduser);
        const currCustomer = tmpData.customer;
        if (currCustomer) {
          try {
            const response = await getCustomer(currCustomer);
            const data = response.data;
            setCustomer(data);
            setEnableTutorials(data.enableTutorial);
          } catch (error) {
            console.error("Failed to reload customer data:", error);
          }
        }
      }
    }
  };
  // Function to get customer data
  const getCustomerData = () => {
    return customer;
  };

  return (
    <CustomerContext.Provider
      value={{
        customer,
        setCustomerData,
        getCustomerData,
        reloadCustomerData,
        enableTutorials
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

// Custom hook to use the CustomerContext
export const useCustomerContext = () => {
  return useContext(CustomerContext);
};
